// Rebuy Search Submit Button Injection
(function() {
  const BUTTON_ID = 'rebuy-search-submit-button';
  let observer = null;
  let buttonInjected = false;
  let loadingClassRemoved = false;

  // Remove loading class from search icon when Rebuy is detected
  function removeLoadingClass() {
    if (loadingClassRemoved) {
      return;
    }

    const rebuySearchContainer = document.querySelector('#rebuy-quick-view-dropdown-search');
    const searchElement = document.querySelector('.header__search--loading');

    if (rebuySearchContainer && searchElement) {
      searchElement.classList.remove('header__search--loading');
      loadingClassRemoved = true;
    }
  }

  // Watch for Rebuy container to appear
  const rebuyLoadObserver = new MutationObserver(function(mutations) {
    removeLoadingClass();

    // If Rebuy is found, we can disconnect this observer
    if (loadingClassRemoved) {
      rebuyLoadObserver.disconnect();
    }
  });

  // Start observing for Rebuy container
  rebuyLoadObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also check immediately in case Rebuy is already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(removeLoadingClass, 100);
    });
  } else {
    setTimeout(removeLoadingClass, 100);
  }

  // Scroll to top when search icon is clicked (works on mobile devices)
  function scrollToTop() {
    // Try smooth scroll first (for desktop)
    try {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    } catch (e) {
      // Fallback for browsers that don't support smooth scroll
      window.scrollTo(0, 0);
    }

    // Direct scroll for mobile devices (more reliable)
    // This ensures it works even if smooth scroll fails
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    if (document.body) {
      document.body.scrollTop = 0;
    }

    // Additional mobile Safari support
    if (window.pageYOffset !== undefined) {
      window.scrollTo(0, 0);
    }
  }

  // Add click handler to search icon
  function addSearchIconScrollHandler() {
    const searchIcon = document.querySelector('.header__icon--search');
    if (searchIcon) {
      searchIcon.addEventListener('click', function() {
        scrollToTop();
      }, { passive: true });
    }
  }

  // Initialize scroll handler when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(addSearchIconScrollHandler, 100);
    });
  } else {
    setTimeout(addSearchIconScrollHandler, 100);
  }

  // Also watch for search icon if it's added dynamically
  const searchIconObserver = new MutationObserver(function(mutations) {
    const searchIcon = document.querySelector('.header__icon--search');
    if (searchIcon && !searchIcon.hasAttribute('data-scroll-handler')) {
      searchIcon.setAttribute('data-scroll-handler', 'true');
      searchIcon.addEventListener('click', function() {
        scrollToTop();
      }, { passive: true });
    }
  });

  searchIconObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  function injectSubmitButton() {
    const container = document.querySelector('.rebuy-quick-view__container');

    if (!container) {
      return false;
    }

    // Check if button already exists
    if (container.querySelector(`#${BUTTON_ID}`)) {
      return true;
    }

    // Get the search input to access the search term
    const searchInput = document.querySelector('#searchInput');

    if (!searchInput) {
      return false;
    }

    // Create wrapper div
    const wrapper = document.createElement('div');
    wrapper.className = 'rebuy-search-submit-wrapper';
    wrapper.style.display = 'none'; // Initially hidden

    // Create button
    const button = document.createElement('button');
    button.id = BUTTON_ID;
    button.className = 'rebuy-search-submit-button';
    button.type = 'button';
    button.textContent = 'View Results';
    button.setAttribute('aria-label', 'View all search results');

    // Function to update button visibility and text based on input value
    function updateButtonState() {
      const searchTerm = searchInput.value.trim();

      if (searchTerm) {
        // Show button and update text with search term
        wrapper.style.display = 'flex';
        button.textContent = `View all results for "${searchTerm}"`;
        button.setAttribute('aria-label', `View all search results for ${searchTerm}`);
      } else {
        // Hide button when input is empty
        wrapper.style.display = 'none';
      }
    }

    // Add input event listener to search input
    searchInput.addEventListener('input', updateButtonState);
    searchInput.addEventListener('keyup', updateButtonState); // Also listen to keyup for better compatibility

    // Initial state check
    updateButtonState();

    // Override close button functionality to clear input instead of closing
    const closeButton = document.querySelector('.rebuy-quick-view-dropdown__close');
    // if (closeButton) {
    //   // Remove any existing click handlers by cloning and replacing
    //   const newCloseButton = closeButton.cloneNode(true);
    //   closeButton.parentNode.replaceChild(newCloseButton, closeButton);

    //   // Add new click handler that clears the input
    //   closeButton.addEventListener('click', function(e) {
    //     e.preventDefault();
    //     e.stopPropagation();

    //     // Clear the search input
    //     searchInput.value = '';

    //     // Trigger input event to update button state
    //     searchInput.dispatchEvent(new Event('input', { bubbles: true }));

    //     // Focus back on the input
    //     searchInput.focus();
    //   });
    // }

    // Add click handler
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      // Try to find the search input value
      let searchTerm = '';
      if (searchInput) {
        searchTerm = searchInput.value || searchInput.getAttribute('value') || '';
      }

      // Try to access Vue component's goToSearchPage method
      const rebuyContainer = document.querySelector('#rebuy-quick-view-dropdown-search');
      if (rebuyContainer && rebuyContainer.__vue__) {
        const vueInstance = rebuyContainer.__vue__;
        if (typeof vueInstance.goToSearchPage === 'function') {
          vueInstance.goToSearchPage();
          return;
        }
        // Try parent component
        if (vueInstance.$parent && typeof vueInstance.$parent.goToSearchPage === 'function') {
          vueInstance.$parent.goToSearchPage();
          return;
        }
      }

      // Fallback: manually navigate to search page
      if (searchTerm && searchTerm.trim()) {
        const searchUrl = `/search?q=${encodeURIComponent(searchTerm.trim())}`;
        window.location.href = searchUrl;
      } else {
        // If no search term, go to search page anyway
        window.location.href = '/search';
      }
    });

    wrapper.appendChild(button);
    container.appendChild(wrapper);
    buttonInjected = true;
    return true;
  }

  function startObserver() {
    if (observer) {
      observer.disconnect();
    }

    observer = new MutationObserver(function(mutations) {
      // Check if container exists
      const container = document.querySelector('.rebuy-quick-view__container');
      if (container && !buttonInjected) {
        // Use setTimeout to ensure Vue has finished rendering
        setTimeout(() => {
          injectSubmitButton();
        }, 100);
      }
    });

    // Start observing the document body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also check immediately in case element already exists
    setTimeout(() => {
      if (injectSubmitButton()) {
        buttonInjected = true;
      }
    }, 500);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }

  // Re-inject if container is removed and re-added (when search is closed and reopened)
  const rebuyObserver = new MutationObserver(function(mutations) {
    const container = document.querySelector('.rebuy-quick-view__container');
    const rebuySearchContainer = document.querySelector('#rebuy-quick-view-dropdown-search');

    if (!rebuySearchContainer) {
      // Container removed, reset flag
      buttonInjected = false;
    } else if (rebuySearchContainer && container && !buttonInjected) {
      // Container exists but button not injected yet
      setTimeout(() => {
        injectSubmitButton();
      }, 200);
    }
  });

  rebuyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
